import React from 'react'

const Button = ({ text, icon, onClick, color = 'primary', disabled = false, enableLoader = false }) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const btnClasses = () => {
    const classes = [
      'text-base',
      'py-2',
      'px-4',
      'font-bold',
      'min-w-[140px]',
      'flex',
      'items-center',
      'justify-center',
      'gap-[10px]'
    ]

    if (color === 'primary') {
      classes.push('bg-[#E9B422]', 'hover:bg-[#FBCD4F]', 'text-black')
    } else {
      classes.push('bg-[#072743]', 'text-white')
    }

    if (disabled) {
      classes.push('opacity-50', 'cursor-not-allowed')
    } else {
      classes.push('cursor-pointer')
    }

    return classes.join(' ')
  }

  const handleClick = () => {
    if (disabled || isLoading) {
      return
    }

    if (enableLoader) {
      setIsLoading(true)
    }

    onClick()

    if (enableLoader) {
      setTimeout(() => {
        setIsLoading(false)
      }, 3000)
    }
  }

  return (
    <div
      className={btnClasses()}
      onClick={handleClick}
      style={{ opacity: isLoading ? 0.7 : 1 }}
    >
      {icon &&
        <div>{ icon }</div>
      }
      {!isLoading ? (
        <div>{ text }</div>
      ) : (
        <svg className="animate-spin h-[24px] w-[33px]" viewBox="0 0 24 24">
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
            fill="none"
          />
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
    </div>
  )
}

export default Button